<tax-modal-header>{{ tariff?.name }}</tax-modal-header>

<tax-modal-content data-qa-block="tariff">
  <div class="price">
    <span class="price-amount" data-qa="tariff-price">{{ tariff?.periodPrice | kzCurrency }}</span>
    <span class="price-period" data-qa="tariff-period">{{
      'tariffs.period.' + tariff?.periodUnit | translate
    }}</span>
  </div>
  <div class="description" data-qa="tariff-description">
    {{ tariff?.fullDescription }}
  </div>
</tax-modal-content>
